import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class DocumentEntityService extends RLBaseService {

	static $inject = ["$resource"];

	constructor(private $resource: ng.resource.IResourceService) {
		super($resource);
	}

	createDocument(templateID: string, parentEntityID: string, charDatas: Models.ICharDatas) {
		var data = {
			templateID: templateID,
			parentEntityID: parentEntityID,
			charDatas: charDatas
		};
		return this.toRLService<{ success: boolean; entityID: string }>("/api/documententity/createdocument").post(data).$promise;
	}
	updateDocument(entityID: string, charDatas: Models.ICharDatas) {
		var data = {
			entityID: entityID,
			charDatas: charDatas
		};
		return this.toRLService<{ success: boolean }>("/api/documententity/updatedocument").post(data).$promise;
	}

	deleteDocument(entityID: string) {
		return this.toRLService<boolean>("/api/documententity/deletedocument").delete({ entityID: entityID }).$promise;
	}

	deleteDocumentVersion(entityID: string, revisionID: number) {
		return this.toRLService<boolean>("/api/documententity/deletedocumentversion").delete({ entityID: entityID, revisionID: revisionID }).$promise;
	}

	getDocumentVersions(entityID: string) {
		return this.toRLService<Models.IDocumentRevisionCollection>("/api/documententity/getdocumentversions").get({ entityID: entityID }).$promise;
	}

	getDownloadUrl(entityID: string, fileName: string) {
		return this.toRLService<Models.IDataResponse<string>>("/api/documententity/getdownloadurl").post({ entityID: entityID, fileName: fileName }).$promise;
	}

	getDocumentDownloadUrl(entityID: string) {
		return this.toRLService<Models.IDataResponse<string>>("/api/documententity/getdocumentdownloadurl").get({ entityID: entityID }).$promise;
	}

	grantFileContactAccess(entityRecIDs: number[], contactRecIDs: number[]) {
		var data = {
			documentEntityRecIDs: entityRecIDs,
			contactRecIDs: contactRecIDs
		};
		return this.toRLService<void>("/api/documententity/grantfilecontactaccess").post(data).$promise;
	}

	revokeFileContactAccess(entityRecIDs: number[], contactRecIDs: number[]) {
		var data = {
			documentEntityRecIDs: entityRecIDs,
			contactRecIDs: contactRecIDs
		};
		return this.toRLService<void>("/api/documententity/revokefilecontactaccess").post(data).$promise;
	}

	sendForSignature(parentID: string, documentID: string, emailList: string[]) {
		var data = {
			parentEntityID: parentID,
			documentEntityID: documentID,
			emailList: emailList
		};
		return this.toRLService<{ success: boolean }>("/api/documententity/sendforsignature").post(data).$promise;
	}

	getAssociatedUsers(entityID: string) {
		return this.toRLService<Models.IDataResponse<Models.IEntitySearchDoc[]>>("/api/documententity/GetAssociatedUsers").get({ entityID: entityID }).$promise;
	}

	UploadFolder(entityID: string, folderTemplateID: number, fileTemplateID: number, orignalFilePaths: string[], filePickerPaths: string[]) {
		var data = {
			entityID: entityID,
			folderTemplateID: folderTemplateID,
			fileTemplateID: fileTemplateID,
			originalFilePaths: orignalFilePaths,
			filePickerPaths: filePickerPaths
		};
		return this.toRLService<Models.IJobResponse>("/api/documententity/uploadfolder/").post(data).$promise;
	}

	deleteDocumentFolder(entityID: string) {
		return this.toRLService<Models.IJobResponse>("/api/documententity/deletedocumentfolder").delete({ entityID: entityID }).$promise;
	}

	grantContactAccess(entityRecIDs: number[], contactRecIDs: number[]) {
		var data = {
			documentEntityRecIDs: entityRecIDs,
			contactRecIDs: contactRecIDs
		};
		return this.toRLService<Models.IJobResponse>("/api/documententity/grantcontactaccess").post(data).$promise;
	}

	revokeContactAccess(entityRecIDs: number[], contactRecIDs: number[]) {
		var data = {
			documentEntityRecIDs: entityRecIDs,
			contactRecIDs: contactRecIDs
		};
		return this.toRLService<Models.IJobResponse>("/api/documententity/revokecontactaccess").post(data).$promise;
    }

    getFileStackSignature(expiry: number) {
        var data = {
            expiry: expiry
        };
        return this.toRLService<Models.IFileStackSignatureResponse>("/api/documententity/filestacksignature").post(data).$promise;
    }
}